module.exports = __webpack_public_path__ + "img/logo-ticketshop.ecb5d783.png";